import type { FaireProductEntity } from "../../entity_types/product";

export const p_4v2mwtgjzx: FaireProductEntity = {
  token: "p_4v2mwtgjzx",
  type: "product",
  name: "Rye Water Glass / Beer Glass Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/b63c83891ef430116e66eba6dc83cb14d58d338fca26ad379274fa6b8490eb52.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24180dd03efba2a37fc5716039fd9c6a7097a2a4f362d87b1e6e6a6d9869df04.jpeg",
    "https://cdn.faire.com/fastly/5be7d6af048e14129bdcb1a20dbee04a79f8856821762fd9117acd6b4f7400da.jpeg",
    "https://cdn.faire.com/fastly/8b54c4f8fa1e8329339b7b9c60ff6d798f0e597f2d8a33d615cc6436f629d57c.jpeg",
    "https://cdn.faire.com/fastly/4f9e4ce14ee7948c288d1072a798e02eef48d4575d3e194d293f5209fb0bee5f.jpeg",
    "https://cdn.faire.com/fastly/846b7f30bdbf9ae8b3ab4e76d1c73cafffaa787a84bea1571aa588e00cd10654.jpeg",
    "https://cdn.faire.com/fastly/e9407ba3df9fc39b92dff66e6666f3583bad388ab86d5410554a94f735de0c7e.jpeg",
    "https://cdn.faire.com/fastly/178b2d25aaad1ff15ee39b6c9cc5a329b5e8304a834755ad4b03070e8f61f633.jpeg",
    "https://cdn.faire.com/fastly/436c06a9d5c8764c84f6c0dcab645b9e04e38b560bc55cf7caae127fba64d5b2.jpeg",
    "https://cdn.faire.com/fastly/2f88c78ed97ab393de926bec254613aeb953cb59fc64fd8a7cf2e63ed306c7c7.jpeg",
  ],
  priceDollars: 26.25,
  description:
    'RYE glassware range has been designed to elevate the drinking experience, whether it is water, beer, wine or a meticulously mixed cocktail. The glasses are skilfully hand crafted from a robust borosilicate glass. The range is well-proportioned, graphic in form, and the subtle accent of coloured glass elevates the drink whilst still allowing you to appreciate the shade of the drink.\n\nThis size is perfect for iced water and your favourite lagers, ales and every other craft beer.\n\n• Packed as a set of 2.\n• Size: D 8.5cm x H 9.5cm / D 3.35" x H 3.7"\n• Capacity: 430ml / 14.5 fl oz',
  tags: [],
  msrpDollars: 52.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:30.405Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
